import axios from 'axios';
import { API_URL } from 'configs'

export const WORKSPACE_ACCESS_REQUEST = 'WORKSPACE_ACCESS_REQUEST'
export const WORKSPACE_ACCESS_SUCCESS = 'WORKSPACE_ACCESS_SUCCESS'
export const WORKSPACE_ACCESS_VALIDATION_ERROR = 'WORKSPACE_ACCESS_VALIDATION_ERROR'
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_WORKSPACE_ACCESS_FIELD_VALIDATION_ERROR = "HIDE_WORKSPACE_ACCESS_FIELD_VALIDATION_ERROR"
export const REDIRECT_TO_WORKSPACE_ACCESS_LIST = 'REDIRECT_TO_WORKSPACE_ACCESS_LIST'
export const ACTIVITY_ACCESS_ROLE_SUCCESS = 'ACTIVITY_ACCESS_ROLE_SUCCESS'
export const WORKSPACE_ACCESS_GET_SUCCESS = 'WORKSPACE_ACCESS_GET_SUCCESS'
export const WORKSPACE_ACCESS_SERVER_SUCCESS = 'WORKSPACE_ACCESS_SERVER_SUCCESS'
const SHOW_LOADER = 'SHOW_LOADER';
const HIDE_LOADER = 'HIDE_LOADER';

const showCommonLoader = (label = '') => ({
  type: SHOW_LOADER,
  common_loder_label: label
})
const hideCommonLoader = () => ({
  type: HIDE_LOADER,
})

const workspaceAccessRequest = () => ({
  type: WORKSPACE_ACCESS_REQUEST,
})

export const worspaceAccessServerListAccess = () => ({
  type: WORKSPACE_ACCESS_SERVER_SUCCESS,
})

const worspaceAccessListSuccess = workspaceAccessList => ({
  type: WORKSPACE_ACCESS_SUCCESS,
  workspaceAccessList: workspaceAccessList,
})



const workspaceAccessFailure = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'general_error'
})
const validationError = notification => ({
  type: WORKSPACE_ACCESS_VALIDATION_ERROR,
  validation_error: notification,
})
const tokenError = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'token_expire'
})

const workspaceAccessAddUpdateSuccess = (message, action, dispatch) => {
  dispatch(workspaceAccessSuccessNotification(message))
  dispatch(redirectToWorkspaceAccessList())
}

export const redirectToWorkspaceAccessList = () => ({
  type: REDIRECT_TO_WORKSPACE_ACCESS_LIST,
})

const getWorkspaceAccessSuccess = (response, action) => ({
  type: WORKSPACE_ACCESS_GET_SUCCESS,
  record: response,
  actionType: action
})

const workspaceAccessSuccessNotification = message => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: 'success'
})

export const hideWorkspaceAccessValidationError = (feild_key) => ({
  type: HIDE_WORKSPACE_ACCESS_FIELD_VALIDATION_ERROR,
  feild_key: feild_key
})

export const workspaceAccessListFetch = () => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(workspaceAccessRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "workspace_access/getAll", {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
    })
      .then((response) => {
        dispatch(worspaceAccessListSuccess(response.data))
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error, dispatch)
        dispatch(hideCommonLoader())
      });

  }
}



export const addWorkspaceAccess = (data) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(workspaceAccessRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "workspace_access/create", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: data,
    })
      .then((response) => {
        workspaceAccessAddUpdateSuccess('Workspace Access Added Successfully', 'create', dispatch)
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error, dispatch)
        dispatch(hideCommonLoader())
      });

  }
}

export const updateWorkspaceAccess = (data) => {
  console.log('data',data);
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(workspaceAccessRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "workspace_access/update/" + data.id, {
      method: "PUT",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer  ' + token
      },
      data: data
    })
      .then((response) => {
        workspaceAccessAddUpdateSuccess('Workspace Access Updated Successfully', 'update', dispatch)
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error, dispatch)
        dispatch(hideCommonLoader())
      });

  }
}

export const getWorkspaceAccessById = (workspace_id, action) => {
  console.log('workspace_id',workspace_id);
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(workspaceAccessRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "workspace_access/getById/" + workspace_id, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer  ' + token
      },
    })
      .then((response) => {
        dispatch(getWorkspaceAccessSuccess(response.data, action))
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error, dispatch)
        dispatch(hideCommonLoader())
      });

  }
}

export const deleteWorkspaceAccess = (workspace_id, object_viewed_id) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(workspaceAccessRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "workspace_access/delete/" + workspace_id, {
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: {
        object_viewed_id
      }
    })
      .then((response) => {
        dispatch(workspaceAccessSuccessNotification('Workspace Access deleted successfully'))
        dispatch(workspaceAccessListFetch())
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error, dispatch)
        dispatch(hideCommonLoader())
      });
  }

}

// handling error reponse   
const handleErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {
      dispatch(validationError(error.response.data.error))
    }
    else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()))
    }
    else {
      let err = '';
      if (error.response.data.error) {
        err = error.response.data.error.toString()
      }
      else {
        err = error.response.status + ` ` + error.response.statusText
      }
      dispatch(workspaceAccessFailure(err))
    }
  }
  catch (e) {
    dispatch(workspaceAccessFailure('Unable to perform action.Something went wrong'))
  }
}   